<template>
    <div class="search-box">
        <el-form ref="searchFormRef" :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="状态" prop="extend1">
                <el-select v-model="formInline.extend1" clearable placeholder="请选择">
                    <el-option label="已读" value="1" />
                    <el-option label="未读" value="2" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="onReset(searchFormRef)">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="table-box">
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="feedbackContent" label="内容" align="center" />
            <el-table-column prop="extend1" label="状态" align="center" width="140px">
                <template #default="scope">
                    <el-tag :type="scope.row.extend1 === '1' ? 'success' : 'danger'">
                        {{ scope.row.extend1 === '1' ? '已读' : '未读' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
                <template #default="scope">
                    <el-button type="primary" :disabled="scope.row.extend1 == 1" size="small"
                        @click="editFn(scope.row)">设为已读</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
            :page-sizes="[10, 50, 100, 200]" :small="small" :background="background"
            layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
    </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { InfoFilled, ArrowRightBold, ArrowDownBold } from "@element-plus/icons-vue";
import service from "@/http/request.js";
const tableData = ref([]);

const formInline = reactive({
    extend1: null,
});
const searchFormRef = ref();
const onSubmit = () => {
    _pageList();
};
const onReset = (formEl) => {
    formEl.resetFields();
    pageSize.value = 10;
    currentPage.value = 1;
    _pageList();
};
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const handleSizeChange = (val) => {
    pageSize.value = val;
    _pageList();
};
const handleCurrentChange = (val) => {
    currentPage.value = val;
    _pageList();
};
const _pageList = () => {
    service.post('/health/web/feedback/page', {
        pageSize: pageSize.value || null,
        pageNo: currentPage.value || null,
        ...formInline
    })
        .then(data => {
            console.log(data)
            if (data.data.code == 200) {
                tableData.value = data.data.data.records
                total.value = data.data.data.total
            }
        })
        .catch(err => {
            ElMessage({
                message: err.message,
                type: "error",
            });
        })
};

const editFn = (row) => {
    service.post('/health/web/feedback/update', {
        id: row.id,
        extend1: 1
    })
        .then(data => {
            console.log(data)
            if (data.data.code == 200) {
                ElMessage({
                    message: "操作成功",
                    type: "success",
                });
                _pageList();
            }
        })
        .catch(err => {
            ElMessage({
                message: err.message,
                type: "error",
            });
        })
};


onMounted(() => {
    _pageList();
});

const handleToggle = (row) => {
    row.expanded = !row.expanded;
};
</script>
<style scoped lang="scss">
.flex {
    display: flex;
}

.items-center {
    align-items: center;
}

.justify-center {
    justify-content: center;
}

.success {
    color: #02bc6c;
}

.red {
    color: #da0f0f;
}
</style>
